import { render, staticRenderFns } from "./VSearchBar.vue?vue&type=template&id=4f6fda35&scoped=true&"
import script from "./VSearchBar.vue?vue&type=script&lang=ts&"
export * from "./VSearchBar.vue?vue&type=script&lang=ts&"
import style0 from "./VSearchBar.vue?vue&type=style&index=0&id=4f6fda35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6fda35",
  null
  
)

export default component.exports